(function(){
  'use strict';

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cleanSwiperNode(node) {
    if (!node || !node.classList) return;
    var toRemove = [];
    for (var i = 0; i < node.classList.length; i++) {
      var name = node.classList[i];
      if (name && name.indexOf('swiper-') === 0 && name !== 'swiper') toRemove.push(name);
    }
    toRemove.forEach(function(name) { node.classList.remove(name); });
  }

  function initHmcSwiper() {
    if (typeof Swiper === 'undefined') return;
    var containers = document.querySelectorAll('[data-hmcswiper="true"]');
    if (!containers.length) return;

    containers.forEach(function(container) {
      var node = container.querySelector('.swiper');
      if (!node) return;
      if (node.hmcSwiper) {
        try {
          node.hmcSwiper.destroy(true, true);
          node.hmcSwiper = null;
          cleanSwiperNode(node);
        } catch(e) {}
      }

      try {
        var optsAttr = container.getAttribute('data-options');
        var base = {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: prefersReducedMotion ? 0 : 300,
          breakpoints: {}
        };
        var extra = {};
        if (optsAttr) {
          try { extra = JSON.parse(optsAttr); } catch(e) {}
        }

        var style = getComputedStyle(container);
        var gapMobile = parseInt(style.getPropertyValue('--hmc-gap-mobile'), 10) || 16;
        var gapTablet = parseInt(style.getPropertyValue('--hmc-gap-tablet'), 10) || 16;
        var gapDesktop = parseInt(style.getPropertyValue('--hmc-gap-desktop'), 10) || 16;
        var spm = parseFloat(style.getPropertyValue('--hmc-slides-mobile')) || 1;
        var spt = parseFloat(style.getPropertyValue('--hmc-slides-tablet')) || 2;
        var spd = parseFloat(style.getPropertyValue('--hmc-slides-desktop')) || 4;
        if (spm < 0.1) spm = 1;
        if (spt < 0.1) spt = 2;
        if (spd < 0.1) spd = 4;
        if (gapMobile < 0) gapMobile = 0;
        if (gapTablet < 0) gapTablet = 0;
        if (gapDesktop < 0) gapDesktop = 0;

        base.spaceBetween = gapMobile;
        base.slidesPerView = spm;
        base.slidesOffsetAfter = 20;
        base.breakpoints = {
          768: { slidesPerView: spt, spaceBetween: gapTablet, slidesOffsetAfter: 0 },
          992: { slidesPerView: spd, spaceBetween: gapDesktop, slidesOffsetAfter: 0 }
        };
        if (prefersReducedMotion && extra.autoplay) extra.autoplay = false;

        var paginationEl = container.querySelector('.swiper-pagination');
        if (extra.pagination && paginationEl) {
          base.pagination = {
            el: paginationEl,
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active'
          };
        }
        var section = container.closest('[id^="hmc-"]');
        if (section && typeof extra.hide_arrows_mobile === 'boolean') {
          if (extra.hide_arrows_mobile === true) {
            section.setAttribute('data-hide-arrows-mobile', 'true');
            section.classList.add('hmc-hide-arrows-mobile');
          } else {
            section.removeAttribute('data-hide-arrows-mobile');
            section.classList.remove('hmc-hide-arrows-mobile');
          }
        }
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var useNavigation = isMobile ? (extra.hide_arrows_mobile !== true) : (extra.show_arrows_desktop === true || extra.navigation === true);
        if (useNavigation) {
          var searchRoot = section || container;
          var nextEl = searchRoot.querySelector('.swiper-button-next');
          var prevEl = searchRoot.querySelector('.swiper-button-prev');
          if (nextEl && prevEl) {
            base.navigation = { nextEl: nextEl, prevEl: prevEl, disabledClass: 'swiper-button-disabled' };
          }
        }

        if (extra.loop) {
          base.loop = true;
          var wrapper = node.querySelector('.swiper-wrapper');
          var slides = wrapper ? wrapper.querySelectorAll('.swiper-slide') : [];
          if (slides.length > 0) base.loopedSlides = slides.length;
        }
        if (extra.autoplay) base.autoplay = extra.autoplay;

        var swiper = new Swiper(node, base);
        node.hmcSwiper = swiper;

        if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
          var section = container.closest('[id^="hmc-"]');
          if (section) {
            document.addEventListener('shopify:section:unload', function unloadHandler(e) {
              var sectionEl = e.target && e.target.nodeType === 1 ? e.target : (e.detail && e.detail.sectionId ? document.getElementById('hmc-' + e.detail.sectionId) : null);
              if (sectionEl === section && swiper && swiper.destroy) {
                swiper.destroy(true, true);
                node.hmcSwiper = null;
                cleanSwiperNode(node);
                document.removeEventListener('shopify:section:unload', unloadHandler);
              }
            });
          }
        }
      } catch(e) {
        if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) console.error('[HMC] Errore init Swiper', e);
      }
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      requestAnimationFrame(function() {
        requestAnimationFrame(initHmcSwiper);
      });
    }, 300);
  });

  function waitForSwiper(cb, max) {
    max = max || 50;
    var attempts = 0;
    function check() {
      attempts++;
      if (typeof Swiper !== 'undefined') cb();
      else if (attempts < max) setTimeout(check, 100);
    }
    check();
  }

  function runInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function onReady() {
        document.removeEventListener('DOMContentLoaded', onReady);
        initHmcSwiper();
      });
    } else {
      initHmcSwiper();
    }
  }
  waitForSwiper(runInit);

  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initHmcSwiper);
  }
})();

// ============================================
// VIDEO AUDIO TOGGLE - New Home Media Carousel
// ============================================
(function(){
  'use strict';

  var initializedToggles = new Set();

  function initHmcVideoAudioToggle() {
    var toggles = document.querySelectorAll('.hmc .video-audio-toggle:not([data-initialized])');
    toggles.forEach(function(toggle) {
      var containerId = toggle.getAttribute('data-video-container');
      if (!containerId) return;
      if (initializedToggles.has(containerId)) return;

      var container = document.querySelector('[data-video-container="' + containerId + '"]');
      if (!container) return;

      var video = container.querySelector('video.hmc-video') || container.querySelector('video');
      if (!video) return;

      if (video.muted !== false) video.muted = true;
      toggle.setAttribute('data-muted', 'true');
      toggle.setAttribute('data-initialized', 'true');

      var handleToggleClick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        var currentVideo = container.querySelector('video.hmc-video') || container.querySelector('video');
        if (!currentVideo) return;
        if (currentVideo.muted) {
          currentVideo.muted = false;
          toggle.setAttribute('data-muted', 'false');
          toggle.setAttribute('aria-label', 'Disattiva audio');
        } else {
          currentVideo.muted = true;
          toggle.setAttribute('data-muted', 'true');
          toggle.setAttribute('aria-label', 'Attiva audio');
        }
      };
      toggle.removeEventListener('click', handleToggleClick);
      toggle.addEventListener('click', handleToggleClick);
      initializedToggles.add(containerId);
    });
  }

  function init() {
    setTimeout(initHmcVideoAudioToggle, 100);
    setTimeout(initHmcVideoAudioToggle, 1000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var sectionToggles = event.detail.container.querySelectorAll('.video-audio-toggle');
      sectionToggles.forEach(function(toggle) {
        toggle.removeAttribute('data-initialized');
        var containerId = toggle.getAttribute('data-video-container');
        if (containerId) initializedToggles.delete(containerId);
      });
      setTimeout(initHmcVideoAudioToggle, 150);
    });
  }
})();